import {
  auth,
  User,
} from "../firebase/firebase-config";
import {
  signInWithRedirect,
  GoogleAuthProvider,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { useState, useEffect } from "react";

const provider = new GoogleAuthProvider();

interface UseAuthReturn {
  user: User | null;
  loading: boolean;
  signInWithGoogle: () => void;
  handleSignOut: () => Promise<void>;
}

export const useAuth = (): UseAuthReturn => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        setUser({
          uid: authUser.uid,
          email: authUser.email,
          displayName: authUser.displayName,
          photoURL: authUser.photoURL,
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const signInWithGoogle = () => {
    setLoading(true);
    signInWithRedirect(auth, provider).catch((error) => {
      console.error("Error during signInWithRedirect:", error);
      setLoading(false);
    });
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  return {
    user,
    loading,
    signInWithGoogle,
    handleSignOut,
  };
};
